
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_gwq0h_lnh1z_97",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_lnh1z_1",
  "trigger-expanded": "awsui_trigger-expanded_gwq0h_lnh1z_119",
  "icon": "awsui_icon_gwq0h_lnh1z_133",
  "root": "awsui_root_gwq0h_lnh1z_151",
  "expanded": "awsui_expanded_gwq0h_lnh1z_169",
  "icon-container": "awsui_icon-container_gwq0h_lnh1z_173",
  "trigger": "awsui_trigger_gwq0h_lnh1z_119",
  "trigger-default": "awsui_trigger-default_gwq0h_lnh1z_188",
  "trigger-footer": "awsui_trigger-footer_gwq0h_lnh1z_191",
  "trigger-navigation": "awsui_trigger-navigation_gwq0h_lnh1z_197",
  "trigger-container": "awsui_trigger-container_gwq0h_lnh1z_209",
  "header": "awsui_header_gwq0h_lnh1z_219",
  "header-container": "awsui_header-container_gwq0h_lnh1z_222",
  "header-navigation": "awsui_header-navigation_gwq0h_lnh1z_229",
  "content": "awsui_content_gwq0h_lnh1z_97",
  "content-default": "awsui_content-default_gwq0h_lnh1z_265",
  "content-footer": "awsui_content-footer_gwq0h_lnh1z_268",
  "content-expanded": "awsui_content-expanded_gwq0h_lnh1z_271",
  "focusable": "awsui_focusable_gwq0h_lnh1z_275"
};
  